/*
 * @Author: 张强 765721622@qq.com
 * @Date: 2022-06-06 10:14:34
 * @LastEditors: 张强 765721622@qq.com
 * @LastEditTime: 2022-06-06 11:54:29
 * @FilePath: /company-official-website/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import INZ from './inz';
import Vue from 'vue';
INZ.Vue = Vue;
import App from './App';
import VueRouter from 'vue-router';
import Routers from './router';
import './styles/iconfont/iconfont.css'
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';

// window.clientUrl = "http://39.107.98.86:3000";
window.clientUrl = "https://visit.beecode.cn";

//避免重复点击路由报错 
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);
Vue.use(iView);

INZ.eventBus = new Vue();

Vue.config.productionTip = false
window.addEventListener('unload', () => {
    window.scrollTo(0, 0)
})
console.log = function() {}

Vue.prototype.$Message.config({
    top: 100,
})
let init = function() {

    // 路由配置
    const RouterConfig = {
        mode: 'history',
        routes: Routers,
        base: '/',
    };

    const router = new VueRouter(RouterConfig);
    let vueObject = {
        router: router,
    };
    router.beforeEach((to, from, next) => {
        next();
    });

    router.afterEach((to, from, next) => {
        window.scrollTo(0, 0);
    });

    INZ.Vue = vueObject;

    new Vue({
        // store:store,
        el: '#app',
        router: router,
        render: h => h(App)
    });
};
init();


// WEBPACK FOOTER //
// ./src/main.js